import { Box } from '@mui/material';
import { hasActiveModuleGrant } from '@realadvisor/constants';

import { useAppData } from '@modules/_shared/providers/AppDataProvider';
import { UserLeadsCard } from '@modules/users/user-overview/components/UserLeadsCard';
import { UserListingsCard } from '@modules/users/user-overview/components/UserListingsCard';
import { MODULES_BROKERAGE } from '@shared/constants/module';

type UserSellingProps = {
  userId: string;
};

export const UserSelling = ({ userId }: UserSellingProps) => {
  const { me } = useAppData();

  return (
    <Box
      sx={{
        p: 2,
        maxWidth: 1400,
        mx: 'auto',
        width: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: 2,
          alignItems: 'flex-start',
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0, width: { xs: '100%', md: 'auto' } }}>
          <UserLeadsCard userId={userId} variant="selling" defaultExpanded />
        </Box>
        {hasActiveModuleGrant(me?.module_grants, MODULES_BROKERAGE) && (
          <Box sx={{ flex: 1, minWidth: 0, width: { xs: '100%', md: 'auto' } }}>
            <UserListingsCard userId={userId} defaultExpanded />
          </Box>
        )}
      </Box>
    </Box>
  );
};
